/**
 * Form input manipulation
 *
 * @since   1.0.0
 * @package uma
 */

(function($) {

	if ( $('.newsletter').length ) {

		// clone the users email input into the gravity forms email input
		$('#uma-newsletter-email').change(function() {
		    $('.uma-email input').val($(this).val());
		    $('.uma-newsletter-type input').val($('#uma-newsletter-select').val());
		});
		$('#uma-newsletter-select').change(function() {
		    $('.uma-newsletter-type input').val($(this).val());
		});
		// clone the users check input into the gravity forms check input
		$('#uma-newsletter-agree').change( function() {
			if ( $('#uma-newsletter-agree').is(':checked') ) {
				$(".uma-agree input").prop('checked', true);
			} else {
				$(".uma-agree input").prop('checked', false);
			}
		});

		// simulate click on hidden form submit
		$('#uma-newsletter-submit').on('click', function() {
			$('.gform_footer button[role="button"]').trigger('click');
		});

		// add error class to inputs if error
		if ( $('.uma-email').hasClass('gfield_error') ) {
			$('<span class="uma-email-error">A Valid Email is Required</span>').insertBefore('#newsletter-input-form');
			$('#uma-newsletter-email').toggleClass('uma-invalid');
		}

		if ( $('.uma-agree').hasClass('gfield_error') ) {
			$('<span class="uma-agree-error">Must agree to register</span>').insertAfter('#newsletter-input-form');
			$('#uma-newsletter-agree').toggleClass('uma-invalid');
		}

	}

}(jQuery));